<h1>My Workflows</h1>
@defer (when gridData) {
  @if (gridData.length > 0) {
    <workflow-table [gridData]="gridData"/>
  }
  @if (gridData.length === 0 && !isLoading) {
    <div class="statement">
      <span>You have no workflows available</span>
      <button matButton="filled" type="button" (click)="onCreate()">Create a workflow</button>
    </div>
  }
} @loading {
  <div class="statement"><span>Loading workflows...</span></div>
} @error {
  <div class="statement"><span>Error loading workflows</span></div>
} @placeholder () {
  <div class="statement"><span>My Workflows</span></div>
}
